import { toDecimalPoint } from '@round/utils';
import styles from './RelativeValueLabel.module.css';
import cn from 'classnames';
import { numberWithCommas } from 'helpers';

type Props = {
    value: number;
};

const RelativeValueLabel = ({ value }: Props) => {
    return (
        <span
            className={cn(styles.value, {
                [styles.negative]: value < 0,
                [styles.positive]: value > 0,
            })}
        >
            ({value > 0 ? '+' : ''}
            {numberWithCommas(toDecimalPoint(value * 100, 3))}%)
        </span>
    );
};

export default RelativeValueLabel;
